import { useMemo } from 'react'

import { useRequest } from 'ahooks'
import { createStyles } from 'antd-style'

import { queryMallTradingRankingListApi } from '@eastcoal/api/trade/rank/queryMallTradingRankingList'

import { pretty } from '@eastcoal/common/utils/decimal'

import { FloorCard } from '../../../../components/FloorCard'
import { HomeProList } from '../../components/ProList'
import { HomeProListProps } from '../../components/ProList/interface'

import { RankingIndexTag } from './IndexTag'
import { UpDownTag } from './UpDownTag'

const useStyles = createStyles(({ token }) => ({
  list: {
    height: 424,
    overflow: 'auto'
  },
  desc: {
    display: 'flex',
    alignItems: 'center',
    columnGap: token.marginXS,
    fontSize: token.fontSizeSM,
    color: token.colorText
  },
  amount: {
    flex: 'none',
    textAlign: 'right',
    color: token.volcano,
    fontSize: token.fontSizeLG,
    fontWeight: token.fontWeightStrong
  }
}))

export const TradeRankingCard = () => {
  const { data, loading } = useRequest(
    () => queryMallTradingRankingListApi({ topN: 10 }),
    {
      manual: false,
      retryCount: 3,
      retryInterval: 1000
    }
  )

  const { styles } = useStyles()

  const dataSource: HomeProListProps['dataSource'] = useMemo(() => {
    if (!data) return []
    const maxAmountLength = Math.max(
      ...data.map(({ amount = '' }) => amount.toString().length)
    )
    return data.map(
      (
        { id, amount, memberName, currentRanking = 0, oldRanking = 0 },
        index
      ) => {
        const rankingGap = currentRanking - oldRanking
        const isUp = rankingGap > 0
        return {
          id,
          title: memberName,
          desc: (
            <span className={styles.desc}>
              <span>累计成交</span>
              <span
                className={styles.amount}
                style={{ width: `${(maxAmountLength * 4) / 5}em` }}
              >
                {pretty(amount, { currency: true })}
              </span>
            </span>
          ),
          extra: <UpDownTag isUp={isUp} ranking={Math.abs(rankingGap)} />,
          icon: <RankingIndexTag>{index + 1}</RankingIndexTag>
        }
      }
    )
  }, [data])

  return (
    <FloorCard title='交易排行'>
      <HomeProList
        className={styles.list}
        dataSource={dataSource}
        loading={loading}
      />
    </FloorCard>
  )
}
